"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _immutable = require("immutable");

var _colors = require("HubStyleTokens/colors");

var defaults = {
  companyName: '',
  companyDomain: '',
  companyAddressLine1: '',
  companyAddressLine2: '',
  companyCity: '',
  companyState: '',
  companyZip: '',
  companyCountry: '',
  companyLogoUrl: '',
  companyLogoAltText: '',
  companyAvatar: '',
  primaryColor: _colors.HEFFALUMP,
  secondaryColor: '',
  accentColor: '',
  accent2Color: ''
};
var Branding = (0, _immutable.Record)(defaults, 'Branding');

Branding.fromAPI = function (data) {
  var logoUrl = data.logoUrl,
      logoAltText = data.logoAltText,
      common = (0, _objectWithoutProperties2.default)(data, ["logoUrl", "logoAltText"]);
  Object.keys(common).forEach(function (key) {
    return common[key] === null && delete common[key];
  } // Remove null keys
  );
  return new Branding((0, _extends2.default)({}, common, {
    companyLogoUrl: logoUrl || defaults.companyLogoUrl,
    companyLogoAltText: logoAltText || defaults.companyLogoAltText
  }));
};

Branding.toAPI = function (branding) {
  var _toJS = new Branding(branding).toJS(),
      logoUrl = _toJS.companyLogoUrl,
      logoAltText = _toJS.companyLogoAltText,
      primaryColor = _toJS.primaryColor,
      common = (0, _objectWithoutProperties2.default)(_toJS, ["companyLogoUrl", "companyLogoAltText", "primaryColor"]);

  return (0, _extends2.default)({}, common, {
    primaryColor: primaryColor || _colors.HEFFALUMP,
    logoUrl: logoUrl,
    logoAltText: logoAltText
  });
};

var _default = Branding;
exports.default = _default;
module.exports = exports.default;